import React from "react";
import { DIMENSIONS } from "utils/constants/image";
import Image from "components/Image";
import { PRIORITY_FILL } from "utils/constants/ui";

const META_CARD = "meta__card";
const CARD_MAX_WIDTH = 480;

const MetadataCard = ({ title, image, description, url }) => {
  return (
    <div
      className={`${META_CARD} hairline-1 ba br2 bg-white w-100 relative center`}
    >
      <div className="flex flex-column justify-between">
        <div className="flex flex-column justify-between">
          <div
            style={{ height: DIMENSIONS.PRODUCT_CELL.height }}
            className="flex flex-row w-100 overflow-hidden relative"
          >
            <Image src={image} alt={title} {...PRIORITY_FILL} />
          </div>
        </div>
        <div className="z-1 flex flex-column w-100 bt hairline-1 pa2 bg-white f6">
          {title && (
            <div className="pb2 flex w-100 items-center">
              <div className="f5 fw6">{title}</div>
            </div>
          )}
          {description && (
            <div className="w-100 pb2">
              <div className="f6">{description}</div>
            </div>
          )}
          {url && <div className="f7 black-60">{url}</div>}
        </div>
      </div>
      <style jsx>
        {`
          .${META_CARD} {
            max-width: ${CARD_MAX_WIDTH}px;
          }
          .${META_CARD}--content {
            margin-bottom: -4px;
          }
        `}
      </style>
    </div>
  );
};

export default MetadataCard;
